import Vue from 'vue'
import VueRouter from 'vue-router'

//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import Channel from '../pages/Channel.vue'/* 通道 */
import RechargeRecord from '../pages/RechargeRecord.vue'/* 通道 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/mine/details'

import myreport  from '../pages/myreport'
import Moneylog  from '../pages/Moneylog'

Vue.use(VueRouter)

const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'첫 페이지'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'첫 페이지'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'첩을 선택하세요'}},
	{path:'/List',name:'list',component:List,meta:{title:'선택된 첩 목록'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'첩 선택 세부 사항'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'내 거'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'동영상'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'게임'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'로그인'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'등록하다'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'온라인 고객 서비스'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'온라인 고객 서비스'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'설정'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'기본정보'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'실명 변경'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'성별 수정'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'언어 선택'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'충전하다'}},
	{path:'/Channel',name:'Channel',component:Channel,meta:{title:'통로'}},
	{path:'/myreport',name:'myreport',component:myreport,meta:{title:'통로'}},
	{path:'/Moneylog',name:'Moneylog',component:Moneylog,meta:{title:'통로'}},
	{path:'/RechargeRecord',name:'RechargeRecord',component:RechargeRecord,meta:{title:'충전기록'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'결제 비밀번호 관리'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'로그인 비밀번호 관리'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'세부정보 페이지'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'정보발표'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'비디오 재생'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'결제 카드를 작성하세요'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'결제 카드를 작성하세요'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'현금 인출'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'개인 보고서'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'출금기록'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'작업 기록'}},
    {path:'/detail',name:'Details',component:Details}

];

//生成路由实例
const router = new VueRouter({
    routes
})

router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    document.title = to.matched[0].meta.title
    next()
})

export default router